const productCache = new Map<string, any[]>();

export const getCachedProducts = (brandCode: string, subcategory: string) => {
	return productCache.get(`${brandCode}__${subcategory}`) || null;
};

export const setCachedProducts = (brandCode: string, subcategory: string, products: any[]) => {
	productCache.set(`${brandCode}__${subcategory}`, products);
};
